import { BalloonIcon, BalloonKind, NotificationObjectKind, NotificationObjectKindGroup } from "src/model/enum/enumNotifications";

export class NotificationRequest {    
    public ObjectGroup: NotificationObjectKindGroup = NotificationObjectKindGroup.Unknown;
    public ObjectKind: NotificationObjectKind = NotificationObjectKind.UNKNOWN;
    public ObjectID: number = 0;
    
    public PageJump: NotificationRequest_PageJump = null;
    public Popup: NotificationRequest_ShowPopup = null; 
    public Balloon: NotificationRequest_ShowBalloon = null; 
    public Audio: NotificationRequest_PlayAudio = null; 
}

export class NotificationRequest_PageJump {
    public IsEnable: boolean = false;
    public PageID: number = 0;
    public EnvironmentID: number = 0;
    public UsersEnabled: string = "";
}

export class NotificationRequest_ShowPopup {
    public IsEnable: boolean = false;
    public Closable: boolean = false;
    public ImageID: number = 0;
    public Title: string = "";
    public Text: string = "";    
    public UsersEnabled: string = "";
}

export class NotificationRequest_ShowBalloon {
    public IsEnable: boolean = false;
    public Timeout: number = 0;
    public Icon: BalloonIcon = BalloonIcon.None;
    public Kind: BalloonKind = BalloonKind.Single;
    public Title: string = "";
    public Text: string = "";  
    public ImageID: number = 0;  
    public UsersEnabled: string = "";
}

export class NotificationRequest_PlayAudio {
    public IsEnable: boolean = false;
    public Repeat: number = 0;
    public RepeatUntilSolution: boolean = false;
    public Interval: number = 0;
    public Audio: number = 0;
    public UsersEnabled: string = "";
    public solveLater: boolean = false;
}